module.exports = __webpack_public_path__ + "static/media/Absol_gaussian2.d1ddae06.png";